import './index.scss';
import './video-js.scss';





console.log('sripts to be used by all views.');




Array.from(document.querySelectorAll('.myElements'))
    .forEach(
        el => new SimpleBar(el, {
            autoHide: false
        })
); 







